import React from 'react';
import PropTypes from 'prop-types';

import { InputAdornment as MUIInputAdornment } from '@mui/material';

export const InputAdornment = props => <MUIInputAdornment {...props} />;

InputAdornment.propTypes = {
  children: PropTypes.node,
  classes: PropTypes.object,
  disablePointerEvents: PropTypes.bool,
  disableTypography: PropTypes.bool,
  position: PropTypes.oneOf(['start', 'end']).isRequired,
  variant: PropTypes.oneOf(['standard', 'outlined', 'filled'])
};

export default InputAdornment;
